/*
 * @Description:
 * @Author: Luke Z
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-29 14:50:30
 * @LastEditTime: 2021-06-22 11:41:15
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragNDropColumns/index.tsx
 */
/**
 *  Drag and Drop Columns
 *  Author: Luke
 *  CreatedAt: 2021-03-05
 */
import React from 'react';

import css from './css.less';

import { DragNDrop } from '@/src/components';
import Container from 'src/components/DragContainers/LeftMenuIconDragContainer';

import { ActionType, EnumPosition } from 'src/types/common/common';

export { EnumPosition };
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum EnumContainerStyle {
  smallWithBkg = 'smallWithBkg',
  largeWithoutBkg = 'largeWithoutBkg',
}
interface IProps {
  title?: string | JSX.Element;
  titleRightFunction?;
  titleRightText?: string | JSX.Element;
  childGenerate: (data: any, index: number, length: number) => JSX.Element;
  onDelete?: (index: number) => void;
  data: any[];
  droppableId: string;
  onSort;
  onAdd?;
  addText?: string;
  hideTitle?: boolean;
  hideTitleRightFunction?: boolean;
  dragContainerStyle?: EnumContainerStyle;
  hideAdd?: boolean;
  addTextPosition?: EnumPosition;
  addContainerClassName?: string;
  dragContainerClassName?: string;
  amountRestriction?: [number, number];
  displayWarningModalWhenDeleting?: boolean;
  warningModalTitle?: string;
  warningModalContent?: string;
  containerClassName?: string;
  titleRightTextClassName?: string;
  subTitle?: string;
  disabled?: boolean;
  hideDrag?: boolean;
  errorInTitle?: string;
  id?: string;
  disableAddText?: boolean;
  hideAddText?: boolean;
  disableDeleteText?: boolean;
}

const DragNDropColumns = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const [warningVisible, setWarningVisible] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const {
    title,
    titleRightFunction,
    titleRightText,
    childGenerate,
    onDelete,
    data,
    droppableId,
    onSort,
    onAdd,
    addText,
    hideTitle,
    hideAdd,
    disableAddText,
    disableDeleteText,
    amountRestriction,
    hideTitleRightFunction,
    dragContainerStyle = EnumContainerStyle.smallWithBkg,
    addTextPosition = EnumPosition.bottom,
    addContainerClassName,
    dragContainerClassName,
    displayWarningModalWhenDeleting,
    warningModalTitle = getI18n('general.delete'),
    warningModalContent = `${getI18n('general.delete')}?`,
    containerClassName,
    titleRightTextClassName,
    subTitle,
    disabled,
    hideDrag,
    errorInTitle,
    id,
    hideAddText,
  } = props;

  const addClassName = React.useMemo(() => {
    if (addTextPosition === EnumPosition.top) {
      return `${disabled ? css.titleDisabled : ''} ${css.addTopContainer}  ${
        addContainerClassName || ''
      }`;
    }
    return `${css.addContainer} ${addContainerClassName || ''}`;
  }, [addTextPosition]);

  const deleteItem = (index) => {
    if (onDelete) onDelete(index);
  };
  const orderOnChange = (oldIndex: number, newIndex: number) => {
    if (onSort) {
      onSort({ type: ActionType.reorder, data: { newIndex, oldIndex } });
    }
  };

  const moreThanMax = amountRestriction && data.length >= amountRestriction[1];

  const lessThanMin = amountRestriction && data.length <= amountRestriction[0];

  const renderChild = (_d, provided, index) => {
    const { hideDelete } = _d || {};

    return (
      <WarningPopReminder
        placement='topRight'
        visibilityOption={{
          controlledByParent: true,
          controlledVisible: warningVisible && index === selectedIndex,
          setControlledVisible: setWarningVisible,
        }}
        title={warningModalTitle}
        content={warningModalContent}
        onCancelText={getI18n('general.cancel')}
        onCancel={() => {
          setWarningVisible(false);
        }}
        onOkText={getI18n('general.delete')}
        onOk={() => {
          setWarningVisible(false);
          deleteItem(index);
        }}>
        <Container
          hideDrag={hideDrag}
          dragDisabled={disabled}
          containerClassName={containerClassName || ''}
          disableDelete={lessThanMin || disableDeleteText || disabled}
          {...(dragContainerStyle === EnumContainerStyle.largeWithoutBkg
            ? {
                iconClassName: css.iconHandleStyle,
                dragContainerClassName: `${css.dragHandleContainer} ${
                  dragContainerClassName || ''
                }`,
              }
            : {
                dragContainerClassName: `${dragContainerClassName || ''}`,
              })}
          dragProps={provided.dragHandleProps}
          {...(onDelete && !hideDelete
            ? {
                onDelete: () => {
                  setSelectedIndex(index);
                  if (displayWarningModalWhenDeleting) {
                    setWarningVisible(true);
                  } else {
                    deleteItem(index);
                  }
                },
              }
            : {})}>
          {childGenerate ? childGenerate(_d, index, data.length) : null}
        </Container>
      </WarningPopReminder>
    );
  };
  return (
    <div className={css.container} id={id}>
      {!hideTitle && (
        <div className={css.titleRow}>
          <div className={css.titleContainer}>
            <div>{title}</div>
            {subTitle && (
              <div className={css.subTitleContainer}>{subTitle}</div>
            )}
            {errorInTitle && (
              <div className={css.errInTitle}>{errorInTitle}</div>
            )}
          </div>
          {!hideTitleRightFunction && (
            <div
              className={`${css.titleDeleteAll} ${
                disabled ? css.titleDisabled : ''
              } ${titleRightTextClassName || ''}`}
              onClick={!disabled && titleRightFunction}>
              {titleRightText || getI18n('general.dragNDropColumns.delete_all')}
            </div>
          )}
        </div>
      )}

      {!hideAdd && addTextPosition === EnumPosition.top && (
        <div className={addClassName} onClick={!disabled && onAdd}>
          {addText}
        </div>
      )}
      <div className={`${css.dragContainer} ${dragContainerClassName || ''}`}>
        <DragNDrop
          droppableId={droppableId}
          disableAllDrags={disabled}
          list={data}
          childGenerator={renderChild}
          onChange={orderOnChange}
        />
      </div>
      {(disableAddText || hideAddText) && (
        <div
          className={addClassName}
          style={{
            color: hideAddText ? 'rgba(0,0,0,0)' : '#eee',
            cursor: 'not-allowed',
          }}
          onClick={null}>
          {addText}
        </div>
      )}
      {!hideAdd && addTextPosition === EnumPosition.bottom && (
        <div
          className={addClassName}
          style={{
            color: moreThanMax || disabled ? '#eee' : undefined,
            cursor: moreThanMax || disabled ? 'not-allowed' : undefined,
          }}
          onClick={moreThanMax || disabled ? null : onAdd}>
          {addText}
        </div>
      )}
    </div>
  );
};
export default DragNDropColumns;
